import React, { useMemo } from 'react';
import ScrollingText from '../../../shared/components/ScrollingText';
import { buildSourceData } from './detectionTypeUtils';

const SourcesCard = ({site}) => {
  const data = useMemo(() => buildSourceData(site.data), [site.data]);

  return (
    <div className="gradient sources">
      <h4 className="margin-none section-accent-title section-accent-title--primary sources__header">Sources</h4>
      <div className="sources__list">
        {data.map((item) => {
          return (
            <div key={item.source}
                 className="sources__row">
              <ScrollingText text={item.source} />
              <span>{item.clicks}</span>
            </div>
          );
        })}
        {data.length === 0 && (
          <p className="empty-state margin-none">No sources available.</p>
        )}
      </div>
    </div>
  );
}

export default SourcesCard;
